import React, { Component } from 'react';

export default class ButtonForSelectedWellbores extends Component {
  render() {
    return (
      <button type="button" onClick={this.props.onClick} className="btn btn-outline-dark">{this.props.children}</button>
    );
  }
}
